<template>
  <div class="brief-disenios-abm tipos-disenio">
    <!-- <b-table hover
        responsive="sm" 
        class="registro"
        :items="tiposDisenios" 
        :fields="fields">
      <div slot="table-busy" class="text-center">
        <b-spinner class="table-spinner" label="Spinning" />
      </div>
      <template v-slot:cell(seleccionado)="data">
        <b-form-checkbox
            v-model="data.item.seleccionado"
            :value="Boolean(true)"
            :unchecked-value="Boolean(false)">
        </b-form-checkbox> 
      </template>
    </b-table> -->

    <!-- <div class="subtitulo"> -->
    <div>
      <label>Tipos de Diseño</label>
    </div>

    <b-list-group class="tipos-disenio-list" :key="key" flush>
      <b-list-group-item v-for="tipoDisenio in tiposDisenios" :key="tipoDisenio.tipoDisenioId">
        <b-form-checkbox 
            :id="tipoDisenio.tipoDisenio"
            v-model="tipoDisenio.seleccionado">
            {{ tipoDisenio.tipoDisenio }}
        </b-form-checkbox>
      </b-list-group-item>
    </b-list-group>    

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'brief/getField',
  mutationType: 'brief/updateField',
});

export default {
  name: 'BriefTiposDiseniosABM',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      // fields: [
      //   { 
      //     key: 'tipoDisenio',
      //     label: 'Tipo',
      //   },
      //   {
      //     key: 'seleccionado',
      //     label: '',
      //     class: 'text-center'
      //   },
      // ],

      labelCols: 2,
      key: 0
    }
  },
  computed: {
    ...mapFields([
      'tiposDisenios',
    ]),
  },  
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    refresh() {
      this.key++;
    }    
  },
  watch: {
  }    
}
</script>

<style>
  .brief-disenios-abm.tipos-disenio {
    margin-bottom: 30px;
  }

  .brief-disenios-abm .registro table td[aria-colindex="1"] {
    width: calc(100% - 60px);
  }
  .brief-disenios-abm .registro table td[aria-colindex="2"] {
    width: 60px;
  }

  .brief-disenios-abm .tipos-disenio-list .custom-checkbox {
    padding-left: calc(16.66667% + 12px);
  }
  /* .brief-disenios-abm table tr.table-inactivo {
    color: #a9a9a9;
  } */
</style>